// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__143nX","requiredAsterisk":"Info_requiredAsterisk__3jSXU"};